import { providerApi } from '@/api/ProviderApi'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'

const useFetchStudioAvailability = ({ appointmentId }: { appointmentId: number }) => {
	const {
		data: studioAvailability,
		isFetching,
		error,
	} = useQuery({
		queryKey: ['studio-availability', appointmentId],
		queryFn: () => providerApi.fetchStudioScheduleAvailability(appointmentId),
		select: (data) => {
			return Object.entries(data.nextAvailable).map(([location, date]) => ({
				location,
				date: date ? format(new Date(date), 'MMMM do, yyyy') : 'N/A',
			}))
		},
	})

	return { studioAvailability, isLoading: isFetching, error }
}

export { useFetchStudioAvailability }
